/**
 * @function
 * @author "Alphy Joseph"
 */

import {
  GOOGLE_MAP_URL,
  DEFAULT_MARKER,
  ACTIVE_MARKER,
  MARKER_LABEL,
  DEFAULT_ZOOM,
  STREET_VIEW_SVGPATH,
} from "./_config";
// import mapStyle from "./styles/mapStyle.json";

// const DIRECTION_REQUEST_SAMPLE = {
//   origin: { lat: 13.022, lng: 77.64 },
//   destination: { lat: 12.98, lng: 77.59 },
//   travelMode: "DRIVING",
// };

let mapCenter;

const injectGoogeMapScript = document =>
  new Promise(resolve => {
    if (window.initMap) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = GOOGLE_MAP_URL;
    script.async = true;
    document.body.appendChild(script);
    window.initMap = () => {
      resolve();
    };
  });

const setMapCenter = center => {
  mapCenter = center;
};

const addExtendControlToMap = (map, maps, callback) => {
  const div = document.createElement("div");
  const parentDiv = document.createElement("div");
  const icon = document.createElement("i");
  icon.className = "icomoon-rotate-left";
  div.appendChild(icon);
  div.style.background = "#fff";
  div.style.borderRadius = "2px";
  div.style.margin = "20px 10px";
  div.style.width = "28px";
  div.style.height = "27px";
  div.style.bottom = "90px";
  div.style.position = "absolute";
  div.style.textAlign = "center";
  div.style.lineHeight = "28px";
  div.style.fontSize = "14px";
  div.style.color = "#555";
  parentDiv.appendChild(div);
  parentDiv.style.width = "30px";
  parentDiv.style.height = "100%";
  parentDiv.style.marginRight = "19px";

  div.addEventListener("click", callback);

  map.controls[maps.ControlPosition.TOP_RIGHT].push(parentDiv);
};

const createMap = ({ maps }, mapContainer, location) => {
  const map = new maps.Map(mapContainer, {
    center: location,
    zoom: DEFAULT_ZOOM,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    // styles: mapStyle,
  });

  setMapCenter(location);

  maps.event.addDomListener(window, "resize", () => {
    map.setCenter(mapCenter);
  });

  return map;
};

const selectMarker = ({ maps }, marker) => {
  marker.setIcon({
    path: maps.SymbolPath.CIRCLE,
    ...ACTIVE_MARKER,
    fillColor: marker.markerColor,
    strokeColor: marker.markerColor,
  });

  return marker;
};

const selectSingleMarker = (() => {
  let prevMarker = null;
  return ({ maps }, marker) => {
    if (prevMarker !== null) {
      prevMarker.setIcon({
        path: maps.SymbolPath.CIRCLE,
        ...DEFAULT_MARKER,
        fillColor: prevMarker.markerColor,
        strokeColor: prevMarker.markerColor,
      });
    }

    marker.setIcon({
      path: maps.SymbolPath.CIRCLE,
      ...ACTIVE_MARKER,
      fillColor: marker.markerColor,
      strokeColor: marker.markerColor,
    });

    prevMarker = marker;
    return marker;
  };
})();

const addClickListenerOnMarker = (marker, callback) => {
  marker.addListener("click", () => {
    callback(marker.fcId);
  });
};

const circleMarker = ({ maps }, map, props) => {
  const marker = new maps.Marker({
    ...props,
    map,
    icon: {
      path: maps.SymbolPath.CIRCLE,
      fillColor: props.markerColor,
      strokeColor: props.markerColor,
      ...DEFAULT_MARKER,
    },
    label: {
      ...MARKER_LABEL,
      text: props.label,
    },
  });

  return marker;
};

const personMarker = ({ maps }, map, props) => {
  const marker = new maps.Marker({
    ...props,
    map,
    icon: {
      path: STREET_VIEW_SVGPATH,
      fillColor: props.markerColor,
      fillOpacity: 0.8,
      scale: 0.05,
      strokeColor: "black",
      strokeWeight: 2,
      rotation: 180,
    },
  });

  return marker;
};

// const getDirection = ({ maps }, map) => {
//   const directionsDisplay = new maps.DirectionsRenderer();
//   const directionsService = new maps.DirectionsService();
//   directionsDisplay.setMap(map);
//   directionsService.route(DIRECTION_REQUEST_SAMPLE, (result, status) => {
//     if (status === "OK") {
//       directionsDisplay.setDirections(result);
//     }
//   });
// };

export default {
  setMapCenter,
  injectGoogeMapScript,
  createMap,
  circleMarker,
  personMarker,
  selectMarker,
  selectSingleMarker,
  addClickListenerOnMarker,
  addExtendControlToMap,
  // getDirection,
};



// WEBPACK FOOTER //
// ./src/component/GoogleMap/methods.js